import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './videoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista, salvarOrdem } from './videoActions';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import { getLista as getListaTexto } from '../texto/textoActions';
import TextoInput from '../texto/textoInput';

class Video extends Component {

	state = {
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTexto();
    }

    render() {

        return (
			<>
				<Background
					backgroundPosition={'center'}
					gradientStart='#0F2748'
					gradientEnd='#19CCCC'>
					<Content>
						<Aguardando aguardando={this.props.aguardando} />

						{this.props.modoTela == 'cadastro' ? (
							<Form onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'visualizacao' ? (
							<Form visualizacao onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'exclusao' ? (
							<Form excluir onSubmit={this.props.excluir} />
						) : null}
						{this.props.modoTela == 'lista' ? this.lista() : null}
					</Content>
				</Background>
			</>
        )
    }

	lista() {

		return (
			<>
				<Row alignCenter style={{ marginBottom: 16 }}>
					<Grid cols='12 6 4 3'>
						<Button
							text='Adicionar'
							type={'primary'}
							icon={'fa fa-plus'}
							event={() => {
								this.props.setModoTela('cadastro', {});
								this.props.initForm({});
							}} />
					</Grid>
				</Row>

				{this.props.listaVideoTrilha.map(trilha => {

					const lista = this.props.lista.filter(item => item.trilha == trilha.id);

					return (
						<Row key={trilha.id}>
							{lista.length > 0 &&
							<Grid cols='12 12 12 12'>
								<h5 style={{ backgroundColor: '#0F2748', color: '#ffffff', textAlign: 'center', padding: 8, borderRadius: 10 }}>{trilha.valor}</h5>
							</Grid>}
							<Grid cols='12 12 12 12'>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										flexWrap: 'wrap',
										justifyContent: 'center'
									}}>
									{lista.map((item, i) => (
										<div
											style={{ 
												backgroundColor: '#ffffff',
												display: 'flex',
												flexDirection: 'row',
												margin: 8,
												borderRadius: 10,
												padding: 8,
												width: '100%',
												alignItems: 'center'
											}}>
											<iframe
												width='250px'
												height='150px'
												src={item.link}
												allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
												allowFullScreen></iframe>
											
											<div style={{ width: '50%', marginLeft: 8 }}>
												<label style={{ padding: 2, margin: 0, fontSize: 18, color: '#0F2748' }}>{item.nome}</label>
												<p style={{ padding: 2, margin: 0, fontSize: 14, color: '#0F2748' }}><b>Professor(a): </b>{item.professor}</p>
												<p style={{ padding: 2, margin: 0, fontSize: 14, color: '#0F2748' }}><b>Conteúdo: </b></p>
												{(item.conteudo || '').split('\n').map(linha => (
													<p style={{ padding: 0, margin: 0, marginLeft: 4, fontSize: 14, color: '#0F2748' }}>{linha}</p>
												))}
											</div>								
											<div style={{ margin: 4, textAlign: 'right', width: 'inherit' }}>
												<div style={{ padding: 8 }}>
													<ButtonTable
														type={'primary'}
														icon={'fas fa-pencil-alt'}
														visible={true}
														event={() => {
															this.props.setModoTela('cadastro', {
																...item
															});
															this.props.initForm({
																...item
															});
														}} />

													<ButtonTable
														type={'danger'}
														icon={'fas fa-trash'}
														visible={true}
														event={() => {
															this.props.setModoTela('exclusao', {
																...item
															});
															this.props.initForm({
																...item
															});
														}} />
												</div>
												<div style={{ padding: 8 }}>
													<ButtonTable
														type={'danger'}
														icon={'fas fa-arrow-up'}
														visible={true}
														disabled={i == 0}
														event={() => {
															if (i != 0) {
																let listaNova = lista.map(itemAux => ({ ...itemAux }));

																listaNova[i] = lista[i-1];
																listaNova[i-1] = lista[i];

																this.props.salvarOrdem(listaNova);
															}
														}} />

													<ButtonTable
														type={'success'}
														icon={'fas fa-arrow-down'}
														visible={true}
														disabled={i == lista.length - 1}
														event={() => {
															if (i != lista.length - 1) {
																let listaNova = lista.map(itemAux => ({ ...itemAux }));

																listaNova[i] = lista[i+1];
																listaNova[i+1] = lista[i];

																this.props.salvarOrdem(listaNova);
															}
														}} />
												</div>
											</div>
										</div>
									))}
								</div>
							</Grid>
						</Row>
					);
				})}
			</>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.video.modoTela,
	aguardando: state.video.aguardando,
	lista: state.video.lista,
	videoTitulo: state.texto.lista.filter(item => item.chave == 'videoTitulo').map(item => item.valor)[0],
	listaVideoTrilha: state.video.listaVideoTrilha
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista,
	getListaTexto, salvarOrdem
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Video);
